import { render, staticRenderFns } from "./AbilityProfile.vue?vue&type=template&id=9007a716&scoped=true"
import script from "./AbilityProfile.vue?vue&type=script&lang=js"
export * from "./AbilityProfile.vue?vue&type=script&lang=js"
import style0 from "./AbilityProfile.vue?vue&type=style&index=0&id=9007a716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9007a716",
  null
  
)

export default component.exports